var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatticeAlt3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.44 127.249L179.303 99.2553C184.037 94.4986 191.713 94.4986 196.449 99.2553C201.184 104.012 201.184 111.724 196.449 116.482L160.013 153.09C155.279 157.847 147.601 157.847 142.867 153.09L108.572 118.633L125.717 101.405L151.44 127.249Z",
    fill: "#16B8A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4179 73.418L99.9959 127.248L153.58 73.412C158.316 68.6537 165.992 68.6537 170.726 73.412C175.461 78.1687 175.461 85.881 170.726 90.6392L108.569 153.089C103.835 157.846 96.1588 157.846 91.4224 153.089L29.2714 90.6453C24.5373 85.887 24.5373 78.1748 29.2714 73.418C34.0078 68.6613 41.6838 68.6613 46.4179 73.418Z",
    fill: "#FFB41F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5509 116.487L39.9808 153.088C44.7154 157.845 52.3915 157.845 57.1255 153.088L145.006 64.7944C149.74 60.0377 149.74 52.3255 145.006 47.5687C140.27 42.8104 132.594 42.8104 127.859 47.5687L48.5537 127.248L20.6974 99.2596C15.9616 94.5029 8.28555 94.5029 3.5509 99.2596C-1.18375 104.018 -1.18375 111.73 3.5509 116.487Z",
    fill: "#F56358"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9938 47.5759C59.7284 42.8191 67.4045 42.8191 72.1402 47.5759L125.718 101.406L108.572 118.633L54.9938 64.8031C50.2597 60.0449 50.2597 52.3326 54.9938 47.5759Z",
    fill: "#16B8A2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatticeAlt3);
export default __webpack_public_path__ + "static/media/lattice-alt3.c9b0e0db9954ff7874523a47d5757e8b.svg";
export { ForwardRef as ReactComponent };